module.exports = __webpack_public_path__ + "img/good-01.6553e505.png";